import { useMemo } from "react";
import { Sector } from "../types/Sector";
import { ZoneFilter } from "../types/ZoneFilter";
import { logger } from "../../../utils/logger";

interface UseFilteredDepartmentsProps {
  zonas: Sector[] | undefined;
  zoneFilter: ZoneFilter;
  loadingZonas: boolean;
  errorZonas: string | null;
}

export const useFilteredDepartments = ({
  zonas = [],
  zoneFilter,
  loadingZonas,
  errorZonas,
}: UseFilteredDepartmentsProps): string[] => {
  return useMemo(() => {
    const hasUsableZones = Array.isArray(zonas) && zonas.length > 0;

    // En refrescos silenciosos conservamos las zonas actuales para evitar
    // desmontar todas las filas del calendario mientras llega la respuesta.
    if (loadingZonas && !hasUsableZones) {
      return [];
    }

    if (errorZonas && !hasUsableZones) return [];

    if (!hasUsableZones) {
      return [];
    }

    // Lógica normal cuando ya se cargaron las zonas
    let departamentosFiltrados: string[] = [];

    switch (zoneFilter) {
      case "centro":
        departamentosFiltrados =
          zonas.find((z) => z.id === "centro")?.departamentos || [];
        break;
      case "loma":
        departamentosFiltrados =
          zonas.find((z) => z.id === "loma")?.departamentos || [];
        break;
      case "interno":
        departamentosFiltrados =
          zonas.find((z) => z.id === "interno")?.departamentos || [];
        break;
      default:
        departamentosFiltrados = zonas.flatMap((z) => z.departamentos);
    }

    // Si la lista está vacía, retornar array vacío
    if (departamentosFiltrados.length === 0) {
      logger.warn("⚠️ Lista de departamentos vacía");
      return [];
    }

    return departamentosFiltrados;
  }, [zonas, zoneFilter, loadingZonas, errorZonas]);
};
